export default "__VITE_ASSET__GRAYteqo__"